
























import { Component, Vue, Prop, Inject, Watch } from 'vue-property-decorator';
import { DropDownResponse } from '@/services/__model';
import { KunshanApplicationController, DropDownController } from '@/services/request.service';
import SiblingsDetail from '@/components/SiblingsDetail.vue';
import StudentDetail from '@/components/StudentDetail.vue';
import ApplicantDetail from '@/components/ApplicantDetail.vue';
import EmergencyDetail from '@/components/EmergencyDetail.vue';
import ParentDetail from '@/components/ParentDetail.vue';
import FormRemark from '@/components/FormRemark.vue';
import { getSchoolInfo } from '@/utils/utils';
import fields from '@/fields.config';
import utils from '../utils';
import { flush } from '@sentry/browser';

@Component({
  components: {
    SiblingsDetail,
    StudentDetail,
    ApplicantDetail,
    EmergencyDetail,
    ParentDetail,
    FormRemark,
  },
})
export default class Step3 extends Vue {
  @Inject() public readonly reloadPage!: any;
  @Prop() public gradeList!: Array<DropDownResponse>;
  @Prop() public step1Info!: any;
  @Prop() public step2Info!: any;
  @Prop() public enquiryData!: any;

  public studentDetailInfo: any = {};
  public parentDetailInfo: any = {};
  public guardianDetailInfo: any = {};
  public emergencyDetailInfo: any = {};
  public loading: boolean = false;
  public isShow: boolean = false;
  public isApp: boolean = true;
  public fields = fields;

  public get school() {
    return getSchoolInfo().shortName;
  }

  public get fieldsType() {
    return this.school === 'kcscd' ? 'kcscd' : 'default';
  }
  public created() {}
  @Watch('step2Info', { immediate: true })
  public getStep2Name(): void {
    let optionItem: any = {};
    this.parentDetailInfo = { ...this.step2Info };
    if (this.step2Info.countryId) {
      optionItem = this.$store.state.countryList.filter((item: any) => item.key === this.step2Info.countryId)[0];
      this.parentDetailInfo.countryName = optionItem.value;
      this.parentDetailInfo.countryEnName = optionItem.enValue;
    }
    if (this.step2Info.relationship) {
      optionItem = this.$store.state.memberShipList.filter((item: any) => item.key === this.step2Info.relationship)[0];
      this.parentDetailInfo.relationshipName = optionItem.value;
      this.parentDetailInfo.relationshipEnName = optionItem.enValue;
    }
    if (this.step2Info.sourceId) {
      optionItem = this.$store.state.sourceList.filter((item: any) => item.key === this.step2Info.sourceId)[0];
      this.parentDetailInfo.sourceName = optionItem.value;
      this.parentDetailInfo.sourceEnName = optionItem.enValue;
    }
    if (this.step2Info.highestQualification) {
      optionItem = this.$store.state.academicQualificationList.filter(
        (item: any) => item.key === this.step2Info.highestQualification
      )[0];
      this.parentDetailInfo.highestQualificationName = optionItem.value;
      this.parentDetailInfo.highestQualificationEnName = optionItem.enValue;
    }
    this.guardianDetailInfo = this.step2Info.guardianMobile ? utils.formatGuardianData(this.step2Info) : null;
    if (this.guardianDetailInfo) {
      if (this.step2Info.guardianCountryId) {
        optionItem = this.$store.state.countryList.filter(
          (item: any) => item.key === this.step2Info.guardianCountryId
        )[0];
        this.guardianDetailInfo.countryName = optionItem.value;
        this.guardianDetailInfo.countryEnName = optionItem.enValue;
      }
      if (this.step2Info.guardianRelationship) {
        optionItem = this.$store.state.memberShipList.filter(
          (item: any) => item.key === this.step2Info.guardianRelationship
        )[0];
        this.guardianDetailInfo.relationshipName = optionItem.value;
        this.guardianDetailInfo.relationshipEnName = optionItem.enValue;
      }
      if (this.step2Info.guardianHighestQualification) {
        optionItem = this.$store.state.academicQualificationList.filter(
          (item: any) => item.key === this.step2Info.guardianHighestQualification
        )[0];
        this.guardianDetailInfo.highestQualificationName = optionItem.value;
        this.guardianDetailInfo.highestQualificationEnName = optionItem.enValue;
      }
    }
    this.emergencyDetailInfo = this.step2Info.emergencyMobile ? utils.formatEmergencyData(this.step2Info) : null;
    if (this.emergencyDetailInfo) {
      if (this.step2Info.emergencyRelationship) {
        optionItem = this.$store.state.memberShipList.filter(
          (item: any) => item.key === this.step2Info.emergencyRelationship
        )[0];
        this.emergencyDetailInfo.relationshipName = optionItem.value;
        this.emergencyDetailInfo.relationshipEnName = optionItem.enValue;
      }
    }
  }

  @Watch('step1Info', { immediate: true })
  public getStep1Name(): void {
    if (!this.step1Info) {
      return;
    }
    this.studentDetailInfo = { ...this.step1Info };
    if (this.step1Info.sourceId) {
      let optionItem = this.$store.state.sourceList.filter((item: any) => item.key === this.step1Info.sourceId)[0];
      this.studentDetailInfo.sourceName = optionItem.value;
      this.studentDetailInfo.sourceEnName = optionItem.enValue;
    }
    let optionItem: any = this.$store.state.countryList.filter((item: any) => item.key === this.step1Info.countryId)[0];
    this.studentDetailInfo.countryName = optionItem.value;
    this.studentDetailInfo.countryEnName = optionItem.enValue;
    optionItem = this.$store.state.idTypeList.filter((item: any) => item.key === this.step1Info.idType)[0];
    this.studentDetailInfo.idTypeName = optionItem.value;
    this.studentDetailInfo.idTypeEnName = optionItem.enValue;
    optionItem = this.$store.state.campusList.filter((item: any) => item.key === this.step1Info.campusId)[0];
    this.studentDetailInfo.campusName = optionItem.value;
    this.studentDetailInfo.campusEnName = optionItem.enValue;
    optionItem = this.$store.state.schoolYearAndSemesterList.filter(
      (item: any) => item.key === this.step1Info.schoolYearId
    )[0];

    this.studentDetailInfo.schoolYearName = optionItem.value;
    this.studentDetailInfo.schoolYearEnName = optionItem.enValue;
    optionItem = optionItem.children.filter((item: any) => item.key === this.step1Info.semesterId)[0];
    this.studentDetailInfo.semesterName = this.studentDetailInfo.schoolYearName + ' ' + optionItem.value;
    this.studentDetailInfo.semesterEnName = this.studentDetailInfo.schoolYearEnName + ' ' + optionItem.enValue;
    optionItem = this.gradeList.filter(item => item.key === this.step1Info.sectionId)[0];
    this.studentDetailInfo.sectionName = optionItem.value;
    this.studentDetailInfo.sectionEnName = optionItem.enValue;
    optionItem = this.$store.state.provinceList.filter((item: any) => item.key === this.step1Info.provinceCode)[0];
    this.studentDetailInfo.provinceName = optionItem.value;
    optionItem = this.$store.state.provinceList.filter((item: any) => item.key === this.step1Info.domicileProvince)[0];
    this.studentDetailInfo.domicileProvinceName = optionItem.value;
    optionItem = this.$store.state.englishList.filter((item: any) => item.key === this.step1Info.english)[0];
    this.studentDetailInfo.englishName = optionItem.value;
    this.studentDetailInfo.englishEnName = optionItem.enValue;
    if (this.step1Info.currentSectionId) {
      optionItem = this.gradeList.filter(item => item.key === this.step1Info.currentSectionId)[0];
      this.studentDetailInfo.currentSectionName = optionItem.value;
      this.studentDetailInfo.currentSectionEnName = optionItem.enValue;
    }
    if (this.step1Info.schoolNow) {
      optionItem = this.$store.state.studySchoolList.filter((item: any) => item.key === this.step1Info.schoolNow)[0];
      this.studentDetailInfo.schoolNowName = optionItem.value;
      this.studentDetailInfo.schoolNowEnName = optionItem.enValue;
    }
    if (this.step1Info.provinceCode) {
      this.getCityName(this.step1Info.provinceCode, 'cityCode', 'districtCode');
    }
    if (this.step1Info.domicileProvince) {
      this.getCityName(this.step1Info.domicileProvince, 'domicileCity', 'domicileDistrict');
    }
  }

  public getCityName(value: string, key: string, district: string): void {
    DropDownController.getCityByProvince(value).then(res => {
      const cityList = res && res.data ? res.data : [];
      if (cityList.length > 0) {
        const itemOption = cityList.filter(item => item.key === this.step1Info[key])[0];
        if (!itemOption) {
          return;
        }
        if (key === 'cityCode') {
          this.studentDetailInfo = {
            ...this.studentDetailInfo,
            cityName: itemOption.value,
          };
        } else if (key === 'domicileCity') {
          this.studentDetailInfo = {
            ...this.studentDetailInfo,
            domicileCityName: itemOption.value,
          };
        }
        this.getDistrictName(itemOption.key, district);
      } else {
        if (key === 'cityCode') {
          this.studentDetailInfo = {
            ...this.studentDetailInfo,
            cityName: '',
            districtName: '',
          };
        } else if (key === 'domicileCity') {
          this.studentDetailInfo = {
            ...this.studentDetailInfo,
            domicileCityName: '',
            domicileDistrictName: '',
          };
        }
      }
    });
  }

  public getDistrictName(value: string, key: string): void {
    DropDownController.getDistrictByCity(value).then(res => {
      const districtList = res && res.data ? res.data : [];
      if (districtList.length > 0) {
        const itemOption = districtList.filter(item => item.key === this.step1Info[key])[0];
        if (!itemOption) {
          return;
        }
        if (key === 'districtCode') {
          this.studentDetailInfo = {
            ...this.studentDetailInfo,
            districtName: itemOption.value,
          };
        } else if (key === 'domicileDistrict') {
          this.studentDetailInfo = {
            ...this.studentDetailInfo,
            domicileDistrictName: itemOption.value,
          };
        }
      } else {
        if (key === 'districtCode') {
          this.studentDetailInfo = {
            ...this.studentDetailInfo,
            districtName: '',
          };
        } else if (key === 'domicileDistrict') {
          this.studentDetailInfo = {
            ...this.studentDetailInfo,
            domicileDistrictName: '',
          };
        }
      }
    });
  }

  @Watch('locale', { immediate: false })
  public refreshValue(): void {
    if (JSON.stringify(this.step1Info) !== '{}') {
      this.getStep1Name();
    }
    if (JSON.stringify(this.step2Info) !== '{}') {
      this.getStep2Name();
    }
  }

  public submitForm(): void {
    this.$confirm({
      title: this.$t(`${this.fields[this.fieldsType]['confirmSubmit']}`),
      // content: this.$t(`${this.fields[this.fieldsType]['confirmSubmitTip']}`),
      content: '',
      centered: true,
      okButtonProps: { loading: this.loading } as any,
      onOk: () => {
        if (!this.loading) {
          this.loading = true;
          const data = this.step1Info;
          data.parentInfo = this.step2Info;
          data.parentInfo.email = this.step2Info.email.trim();
          data.studentId = this.$route.query.studentId;
          data.draftId = this.$route.query.draftId;
          data.parentInfo.guardianRequest = data.parentInfo.guardianMobile
            ? utils.formatGuardianData(data.parentInfo)
            : null;
          data.parentInfo.emergencyContactRequest = data.parentInfo.emergencyMobile
            ? utils.formatEmergencyData(data.parentInfo)
            : null;
          KunshanApplicationController.addApplication(data)
            .then(res => {
              this.$emit('changeStep', 'next', 'step3');
              this.$message.success(this.$tc('warningTip.applicantSuccess'));
              this.reloadPage();
              this.$router.push({ name: 'home' });
            })
            .finally(() => {
              this.loading = false;
            });
        }
      },
    });
  }

  public backToPrevStep(): void {
    this.$emit('changeStep', 'prev');
  }

  public get locale(): string {
    return this.$i18n.locale;
  }
}
